import Glide, { Controls, Breakpoints, Images, Swipe, Autoplay  } from '@glidejs/glide/dist/glide.modular.esm';
import $ from 'jquery';
window.$ = $;
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

import '@glidejs/glide/dist/css/glide.core.min.css';
import 'lightgallery/css/lightgallery-bundle.css';
import '../scss/master.scss';

addEventListener('DOMContentLoaded', (event) => 
{
  resizeMobilemenuContainer();

  if( $('.glide').length > 0 )
  {
    let slider = new Glide('.glide', {
      type: 'carousel',
      autoplay: 5000
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  if( $('#mainimage').length > 0  )
  {
    lightGallery( document.getElementById('mainimage'), 
    {
      plugins: [lgZoom, lgThumbnail],
      download: false,
      selector: 'a'
    });
  }

  if( $('#szallas-gallery').length > 0  )
  {
    lightGallery( 
      document.getElementById('szallas-gallery'), 
    {
      plugins: [lgZoom, lgThumbnail],
      speed: 500,
      download: false,
      selector: 'a'
    });

    let szallas_gallery = new Glide('#szallas-gallery', {
      type: 'slider',
      rewind: true,
      autoplay: 2000,
      gap: 5,
      perView: 4,
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  }

  if( $('.etterem-osszefoglalo-holder .napok').length > 0 )
  {
    var d = new Date();
    var wd = d.getDay() - 1;

    let etterem_napok = new Glide('.etterem-osszefoglalo-holder .napok', {
      type: 'slider',
      bound: true,
      startAt: wd,
      focusAt: 'center',
      perView: 3,
      gap: -1,
      breakpoints: {
        1000: {
          perView: 2
        },
        480: {
          perView: 1
        }
      }
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  if( $('.etterem-adatlap .napok').length > 0 )
  {
    var d = new Date();
    var wd = d.getDay();

    let etterem_napok = new Glide('.etterem-adatlap .napok', {
      type: 'slider',
      bound: true,
      startAt: wd,
      focusAt: 'center',
      perView: 3,
      gap: -1,
      breakpoints: {
        1000: {
          perView: 2
        },
        480: {
          perView: 1
        }
      }
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  if( $('.gallery-slide').length > 0 )
  {
    let galleryslide = new Glide('.gallery-slide', {
      type: 'carousel',
      autoplay: 5000,
      perView: 3,
      peek: {
        before: 0,
        after: 250
      },
      breakpoints: {
        640: {
          perView: 1,
          peek: {
            before: 0,
            after: 50
          }
        },
        1000: {
          perView: 2,
          peek: {
            before: 0,
            after: 50
          }
        },
      }
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  if( $('.rolunk-slide').length > 0 )
  {
    let rolunkslide = new Glide('.rolunk-slide', {
      type: 'carousel',
      autoplay: 5000,
      perView: 3,
      breakpoints: {
        640: {
          perView: 1
        },
        1000: {
          perView: 2
        }
      }
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  if( $('.aktualis-slide').length > 0 )
  {
    let aktualisslide = new Glide('.aktualis-slide', {
      type: 'carousel',
      autoplay: 5000,
      perView: 2,
      breakpoints: {
        1000: {
          perView: 1
        }
      }
    }).mount( { Swipe, Controls, Breakpoints, Images, Autoplay } );
  } 

  /** Universal toggler */
	$('*[mb-event]').each( function(i){
		var _ =  $(this).data('mb');
		var op =  (typeof _.tgltext !== 'undefined') ? _.tgltext : 'opened';

    console.log(_);

		switch (_.event) {
			case 'toggleOnClick':
				if ( _.target ) {
					$(_.target).off('mouseenter mouseleave click');
					$(this).on('click', function(){
						var t = $(_.target);
						var opened = t.hasClass(op);
						if ( opened ) {
							t.removeClass(op);
							$(this).removeClass(op);
							$('body').removeClass('mobile-nav');
						} else {
							$('.mb-tgl-close').removeClass(op);
							t.addClass(op);
							$(this).addClass(op);
							$('body').addClass('mobile-nav');
						}
					});
				}
			break;
		}
	} );

  $(window).on('resize', (event) => 
  {
    resizeMobilemenuContainer();
  });

  function resizeMobilemenuContainer()
  {
    let container = $('.mobile-menu-container');
    let wh = $(window).height();
    let header_height = $('body > header').height();
    let contacts_height = $('.mobile-menu > .contacts').height();
    let container_height = wh - (header_height + contacts_height);

    container.css({
      height: container_height+'px'
    });
  }
  

  var lazyloadImages;  
  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if( entry.target.localName == 'div' )
          {
            var div = entry.target;
            div.classList.remove("lazy")
            div.classList.add("lazyloaded");
            div.style.backgroundImage="url("+div.dataset.src+")";
            imageObserver.unobserve(div);
          } else {
            var image = entry.target;
            image.src = image.dataset.src;
            image.classList.remove("lazy");
            image.classList.add("lazyloaded");
            imageObserver.unobserve(image);
          }
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {  
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");
    
    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }    

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }

});